export default defineNuxtPlugin({
  name: 'auth',
  enforce: 'pre',
  async setup() {
    const { init } = useAuth()
    const ready = useAuthReady()
    await init()
    ready.value = true
  },
})
